export default function(filter) {
  return function(photo) {
    return photo.filter === filter || filter === 'all'
  }
}



// WEBPACK FOOTER //
// ./src/utils/filterPhotos.js